import { defineComponent, openBlock, createElementBlock, createElementVNode } from 'vue';
import _export_sfc from './_virtual/plugin-vue_export-helper.mjs';

const _sfc_main = defineComponent({
  name: "CreateTime"
});
const _hoisted_1 = {
  width: "16",
  height: "16",
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
const _hoisted_2 = /* @__PURE__ */ createElementVNode("path", {
  "fill-rule": "evenodd",
  "clip-rule": "evenodd",
  d: "M14.4001 7.99998C14.4001 11.5346 11.5347 14.4 8.0001 14.4C4.46548 14.4 1.6001 11.5346 1.6001 7.99998C1.6001 4.46535 4.46548 1.59998 8.0001 1.59998C11.5347 1.59998 14.4001 4.46535 14.4001 7.99998ZM7.99995 3.97949C8.2945 3.97949 8.53726 4.20122 8.57044 4.48687L8.5743 4.55385V7.42563H10.2974C10.6146 7.42563 10.8717 7.68278 10.8717 7.99999C10.8717 8.29455 10.65 8.53731 10.3644 8.57049L10.2974 8.57435H8.00353C8.00234 8.57436 8.00114 8.57436 7.99995 8.57436C7.74221 8.57436 7.52413 8.40461 7.45141 8.1708C7.44102 8.1374 7.4336 8.10269 7.42945 8.06699L7.42945 8.06698L7.42559 8V7.99999V4.55385C7.42559 4.23664 7.68274 3.97949 7.99995 3.97949Z",
  fill: "#737E99"
}, null, -1);
const _hoisted_3 = [
  _hoisted_2
];
function _sfc_render(_ctx, _cache, $props, $setup, $data, $options) {
  return openBlock(), createElementBlock("svg", _hoisted_1, _hoisted_3);
}
var createTime = /* @__PURE__ */ _export_sfc(_sfc_main, [["render", _sfc_render]]);

export { createTime as default };
